import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-shield-check-line',
    title: 'IT Managed Services',
    description: 'Full-spectrum IT management including monitoring, maintenance, and support for your entire technology environment.',
    anchor: 'it-managed-services',
  },
  {
    icon: 'ri-lock-2-line',
    title: 'Cybersecurity Solutions',
    description: 'Multi-layered security frameworks, threat detection, compliance management, and incident response capabilities.',
    anchor: 'cybersecurity-solutions',
  },
  {
    icon: 'ri-cloud-line',
    title: 'Cloud Computing',
    description: 'Expert cloud strategy, seamless migration services, and ongoing multi-cloud management and optimization.',
    anchor: 'cloud-computing',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'IT Consulting',
    description: 'Strategic technology roadmapping, architecture design, and digital transformation advisory services.',
    anchor: 'it-consulting',
  },
  {
    icon: 'ri-server-line',
    title: 'IT Infrastructure',
    description: 'End-to-end infrastructure deployment, network design, and hardware procurement and lifecycle management.',
    anchor: 'it-infrastructure',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'White-Label SaaS Platform',
    description: 'Fully customizable SaaS platform for HRIS, OMS, LMS, and industry-specific modules — deployed under your own brand.',
    anchor: 'custom-white-label-saas',
  },
  {
    icon: 'ri-database-2-line',
    title: 'Disaster Recovery',
    description: 'Robust backup strategies, business continuity planning, and rapid recovery solutions that minimize downtime.',
    anchor: 'disaster-recovery',
  },
  {
    icon: 'ri-wifi-line',
    title: 'Network Solutions',
    description: 'Secure, high-performance network design and implementation for offices, campuses, and remote environments.',
    anchor: null,
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Mobility & Endpoints',
    description: 'Device management, BYOD policies, and endpoint security solutions for a modern distributed workforce.',
    anchor: null,
  },
];

export default function ServicesGrid() {
  return (
    <section className="py-16 bg-white">
      <div className="mx-auto px-6 lg:px-10 xl:px-16">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-8">
          <span className="eyebrow">Our Expertise</span>
          <h2 className="text-[26px] lg:text-[34px] font-extrabold text-page-ink tracking-[-0.03em] leading-tight mb-3">
            Comprehensive IT Solutions
          </h2>
          <p className="text-page-muted text-base leading-relaxed font-light">
            Every technology discipline your business needs, under one roof.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-white border border-black/[0.08] rounded-2xl p-7 hover:border-[#c97a2b]/40 transition-all duration-300 cursor-pointer shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#c97a2b]/10 border border-[#c97a2b]/20 rounded-xl mb-6 group-hover:bg-[#c97a2b]/20 transition-colors duration-300">
                <i className={`${service.icon} text-[#c97a2b] text-xl`} />
              </div>
              <h3 className="text-[16px] font-bold text-page-ink tracking-[-0.01em] mb-2.5 group-hover:text-[#c97a2b] transition-colors">{service.title}</h3>
              <p className="text-page-muted text-sm leading-relaxed mb-5">{service.description}</p>
              <Link
                to={service.anchor ? `/services#${service.anchor}` : '/services'}
                className="inline-flex items-center gap-1.5 text-[#c97a2b] text-xs font-semibold border border-[#c97a2b]/30 rounded-full px-3 py-1 hover:bg-[#c97a2b]/10 transition-colors whitespace-nowrap"
              >
                Learn more <i className="ri-arrow-right-line text-xs" />
              </Link>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-8">
          <Link
            to="/services"
            className="btn-primary"
          >
            View All Services <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>
      </div>
    </section>
  );
}
